import React from 'react'
import PropTypes from 'prop-types'
import { Fieldset } from 'primereact/fieldset'
import styleMemory from '../../../../../css/generals/Memory.module.css'
import { useTranslation } from 'react-i18next'

export default function Bios ({ bios }) {
  const { t } = useTranslation('hardware')

  return (
    <div style={{ marginTop: '1rem' }}>
        <Fieldset key="bios" legend={t('title2')} toggleable className={ styleMemory.legendHeader }>
            <p><span className={ styleMemory.bold }>{t('label1')}</span><span>{bios?.Manufacturer ? bios?.Manufacturer : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label2')}</span><span>{bios?.Name ? bios?.Name : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label3')}</span><span>{bios?.SerialNumber ? bios?.SerialNumber : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label4')}</span><span>{bios?.version ? bios?.version : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label5')}</span><span>{bios?.ReleaseDate ? bios?.ReleaseDate : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label6')}</span><span>{bios?.BuildNumber ? bios?.BuildNumber : t('notAvailable')}</span></p>
            <p><span className={ styleMemory.bold }>{t('label7')}</span><span>{bios?.SMBIOSBIOSVersion ? bios?.SMBIOSBIOSVersion : t('notAvailable')}</span></p>
        </Fieldset>
    </div>
  )
}

Bios.propTypes = {
  bios: PropTypes.object
}
